export default class NavbarItem 
{
   constructor(linkName, linkTo, icon = "", description = "", isActive = true, index = 0)
   {
    this.LinkName = linkName;
    this.LinkTo = linkTo;
    this.Icon = icon;
    this.Description = description;
    this.IsActive = isActive;
    this.Index = index;
   }
    /** @type {string} */
    LinkName; // required

    /** @type {string} */ 
    LinkTo; // required

    /** @type {string} */
    Icon; // optional

    /** @type {string} */
    Description; // optional

    /** @type {boolean} */
    IsActive; // optional

    /** @type {number} */
    Index; // optional
}